import { Link } from "react-router-dom";

function Name() {
    return (
        <h3 className="Name"><Link to="/" style={{textDecoration: 'none', color: "#3a3a3a"}}>Kate Choe</Link></h3>
    );
}

export default Name;